import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useLoginMutation } from '../api/auth.queries';

export const LoginForm = () => {
  const navigate = useNavigate();
  const loginMutation = useLoginMutation();
  const [formData, setFormData] = useState({
    nrp: '',
    password: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.nrp || !formData.password) {
      toast.error('Please fill in all fields');
      return;
    }

    try {
      await loginMutation.mutateAsync({
        nrp: formData.nrp,
        password: formData.password,
      });
      
      // Navigate to dashboard on successful login
      navigate('/dashboard');
    } catch (error) {
      // Error handling is done by the mutation hook
      console.error('Login error:', error);
    }
  };

  return (
    <Card className="w-full max-w-md bg-slate-950/50 border-slate-800 backdrop-blur-sm text-slate-100">
      <CardHeader className="space-y-1 items-center text-center">
        <div className="w-12 h-12 bg-slate-800 rounded-xl mb-2 flex items-center justify-center">
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
        </div>
        <CardTitle className="text-2xl font-bold tracking-tight">
          Drone MP
        </CardTitle>
        <CardDescription className="text-slate-400">
          Sign in to your account
        </CardDescription>
      </CardHeader>
      <form onSubmit={handleSubmit}>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Input
              id="nrp"
              name="nrp"
              placeholder="nrp"
              value={formData.nrp}
              onChange={handleChange}
              disabled={loginMutation.isPending}
              autoComplete="nrp"
            />
          </div>
          <div className="space-y-2">
            <Input
            type="password"
              id="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              disabled={loginMutation.isPending}
              autoComplete="current-password"
            />
           
          </div>
        </CardContent>
        <CardFooter className="flex flex-col space-y-4">
          <Button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium"
            disabled={loginMutation.isPending}
          >
            {loginMutation.isPending ? 'Signing in...' : 'Sign in'}
          </Button>
        </CardFooter>
      </form>
    </Card>
  );
};
